module.exports = __webpack_public_path__ + "img/p1-info@2x.987ce8a7.jpg";